<template>
  <div>
    <div class="titleBloc d-flex flex-column justify-content-center">
      <div class="title">{{ $tlang(lg1, 'mercure.rates.roomRatesTitle') }}*</div>
      <div class="subtitle">{{ $tlang(lg2, 'mercure.rates.roomRatesTitle') }}*</div>
    </div>
    <div id="rates" class="d-flex flex-column justify-content-top align-items-left" v-if='ratesLg'>
        <div id="header" class="d-flex flex-column justify-content-center align-items-right">
            <div class="title">{{ $tlang(lg1, 'mercure.rates.dayRate') }}</div>
            <div class="subtitle">{{ $tlang(lg2, 'mercure.rates.dayRate') }}</div>
        </div>
        <div id="rows" class="d-flex flex-column justify-content-around align-items-center">
            <row class="rowa" v-for="(rates, index) in ratesLg.lg1.rates2" :key="index" :ratesLg1='rates[0]' :ratesLg2='ratesLg.lg2.rates2[index][0]'></row>
        </div>
        <legalNoticeLeft :legalNoticeLg="legalNoticeLg"></legalNoticeLeft>
    </div>
  </div>
</template>

<script>
import Row from './rowRates'
import LegalNoticeLeft from './legalNoticeLeft'

export default {
  components: {
    row: Row,
    'legalNoticeLeft': LegalNoticeLeft
  },
  name: 'MercureRatesHorizontalV1Rates',
  props: {
    ratesLg: Object
  },
  computed: {
    legalNoticeLg () {
      return {lg1: this.ratesLg.lg1.subtitles['1'], lg2: this.ratesLg.lg2.subtitles['1']}
    },
    lg1 () {
      return this.$store.getters.site.get('rates').get('data').languages[0].name.toLowerCase()
    },
    lg2 () {
      return this.$store.getters.site.get('rates').get('data').languages[1].name.toLowerCase()
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_mercure.scss";

#rates {
  width: 100%;
  height: 100%;

  #header {
    width: 100%;
    @include heightPercent(92);
    text-align: right;
    font-family: Arial;
    @include fontSize(21);
    font-weight: bold;

    .title {
      color: $purple;
    }

    .subtitle {
      color: $gold;
    }
  }

  #rows {
    width: 100%;
    border-bottom: 1px solid $purple;

    .rowa:nth-of-type(n+6){
      display:none!important;
    }
  }
}

</style>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_mercure.scss";

.titleBloc {
  position: absolute;
  @include topPercent(143);
  @include heightPercent(80);
  font-family: "HouschkaAltPro-Bold";
  text-transform: uppercase;

  .title {
      @include fontSize(33);
      color: white;
      padding-top: 0.8vh;
  }

  .subtitle {
      @include fontSize(28);
      color: $gold;
      margin-top: -0.6vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/rates/rates.vue